import { memo } from 'react';
import { useSelector } from 'react-redux';

import { planHasFeature } from '../../helpers/subscription';

import { SUBSCRIPTION_FEATURES } from '../../configs/subscriptions';

const FeatureProvider = ({ children, name, type }) => {
  const userState = useSelector(state => state.user);
  const subscriptionState = useSelector(state => state.subscription);
  const myFeatureGroups = subscriptionState?.myFeatureGroups;
  const myPlan = subscriptionState?.myPlan;

  const isFeatureAvailable = () => {
    if (userState.isAdmin) {
      return true;
    }

    if (type) {
      return planHasFeature(myPlan, type);
    }

    return myFeatureGroups.some(group => !!SUBSCRIPTION_FEATURES?.[group]?.includes(name));
  };

  return isFeatureAvailable() ? children : null;
};

export default memo(FeatureProvider);
